export default __webpack_public_path__ + "static/media/rightarrow.4175af31.svg";